"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _expander = _interopRequireDefault(require("@berlitz/expander"));
var _Footer = require("./Footer.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NavigationColumn = function NavigationColumn(_ref) {
  var title = _ref.title,
    links = _ref.links,
    dataKey = _ref.dataKey,
    showBorder = _ref.showBorder;
  return /*#__PURE__*/_react.default.createElement(_Footer.ColumnWrapper, {
    "data-key": dataKey
  }, /*#__PURE__*/_react.default.createElement(_expander.default, {
    border: showBorder,
    title: title,
    isDisabled: ['lg', 'xl'],
    icon: true
  }, /*#__PURE__*/_react.default.createElement(_Footer.LinkList, {
    "aria-label": title
  }, links.map(function (link, index) {
    return /*#__PURE__*/_react.default.createElement(_Footer.NavLink, {
      key: index
    }, link);
  }))));
};
var _default = NavigationColumn;
exports.default = _default;